export default "__VITE_ASSET__CJqupoO6__"